const spacer = document.querySelector('.secondary-nav__spacer');

if (spacer) {
  const updateURL = (linkId) => {
    const [currentURL] = window.location.href.split('/#');
    const newURL = `${currentURL}${linkId}`;
    if (window.location.href !== newURL) {
      history.replaceState(null, null, linkId);
    }
  };

  const scrollToSection = (sectionElem) => {
    const { top } = sectionElem.getBoundingClientRect();
    window.scrollTo({
      top: top + window.pageYOffset - getHeaderHeight(),
      behavior: 'smooth',
    });
  };

  // Initialize ScrollTrigger for sections
  const initScrollTriggers = () => {
    const navList = document.querySelector('.secondary-nav__list');

    document.querySelectorAll('.secondary-nav__link').forEach((link) => {
      const linkId = link.getAttribute('href');

      if (linkId && linkId !== '#') {
        const sectionElem = document.querySelector(linkId.startsWith('http') ? `[href="${linkId}"]` : linkId);

        if (sectionElem) {
          gsap.timeline({
            scrollTrigger: {
              trigger: sectionElem,
              start: 'top center',
              end: 'bottom center',
              scrub: true,
              onToggle: (self) => {
                if (self.isActive) {
                  updateURL(linkId);

                  if (windowWidth() > breakpointMd) {
                    return;
                  }

                  const linkOffsetLeft = link.offsetLeft;
                  const navListWidth = navList.offsetWidth;
                  const linkWidth = link.offsetWidth;
                  const scrollPosition = linkOffsetLeft - navListWidth / 2 + linkWidth / 2;
                  navList.scroll({
                    left: scrollPosition,
                    behavior: 'smooth',
                  });
                }
              },
              toggleClass: { targets: link, className: 'is-active' },
            },
          });
        }
      }
    });
  };

  // Hide secondary nav for this module on mobile
  const houseMatrixSection = document.querySelector('.sc-house-matrix');
  const houseMatrixId = houseMatrixSection?.getAttribute('id');

  document.querySelectorAll('.secondary-nav__link').forEach((link) => {
    const linkId = link.getAttribute('href');

    if (`#${houseMatrixId}` === linkId) {
      const parent = link.closest('.secondary-nav__item');
      parent.classList.add('house-matrix-nav');
    }

    if (linkId && linkId !== '#') {
      const sectionElem = document.querySelector(linkId.startsWith('http') ? `[href="${linkId}"]` : linkId);

      if (sectionElem) {
        link.addEventListener('click', (ev) => {
          ev.preventDefault();
          scrollToSection(sectionElem);
          updateURL(linkId);
        });
      }
    }
  });

  window.addEventListener('load', initScrollTriggers);
}
